module.exports = __webpack_public_path__ + "static/homepage-2e7dac831dff5e6f85ba4a14964fa58c.jpg";